import axios from "axios";
//import store from "../../app/store/store";

// export const API_URL = "http://192.168.1.23/api/v1";
// export const API_URL = "http://127.0.0.1/api/v1";
// export const API_URL = "http://106.240.173.254/api/v1";
// export const API_URL = "https://waveradmin.ropiklabs.com/api/v1";
export const API_URL = "/api/v1";

// export const axiosApi = axios.create({
//   baseURL: API_URL,
// })
// authToken 주입
// axiosApi.interceptors.request.use(
//   config => {
//       const {
//           auth: { authToken }
//       } = store.getState();

//       if (authToken) {
//           config.headers.Authorization = `Bearer ${authToken}`;
//       }
//       return config;
//   },
//   err => Promise.reject(err)
// );

export const LOGIN_URL = API_URL+"/auth/sign_in/";
export const REGISTER_URL = API_URL+"/auth/sign_up/";
export const CHECK_ID_URL = API_URL+"/auth/check_id/";
export const MAIN_RESPONSE_URL = API_URL+"/waste_collect/my_collect_chart/";
export const CHART_MULTI_URL = API_URL+"/waste_collect/my_multi_collect_chart/";
export const CHART_TOTAL_URL = API_URL+"/waste_collect/my_total_collect_chart/";
export const DASHBOARD_URL = API_URL+"/waste_collect/get_dashboard_data/";
export const NEWS_URL = API_URL+"/news/?page=1";
export const NEWS_BY_PAGE_URL = API_URL+"/news/get_news_by_page/";
export const MY_PROFILE_URL = API_URL+"/member/my_profile/";
// export const CONTRACT_URL = API_URL+"/contract/my_contract_list/";
export const CONTRACT_URL = API_URL+"/contract_company_group/my_contract_list/";
export const MULTI_CONTRACT_URL = API_URL+"/contract_company_group/my_contract_list_with_child/";
export const ALL_STATE_CONTRACT_URL = API_URL+"/contract_company_group/my_all_state_contract_list/";
// export const CONTRACT_PATCH_URL = API_URL+"/contract_company_group/"
export const CONTRACT_PATCH_URL = API_URL+"/contract/insert_contract_file/"
export const COMPANY_URL = API_URL+"/company/";
export const CONTRACT_WRITE_URL = API_URL+"/contract/insert_contract/";
export const CONTRACT_WRITE_HISTORY_URL = API_URL+"/contract_history/";
export const TRADE_HISTORY_URL = API_URL+"/waste_collect/my_collect_list/";
export const MULTI_TRADE_HISTORY_URL = API_URL+"/waste_collect/my_multi_collect_list/";
export const TOTAL_TRADE_HISTORY_URL = API_URL+"/waste_collect/my_total_collect_list/";
export const MEMBER_RESPONSE_URL = API_URL+"/my_profile/"
export const TMS_COMPANY_RESPONSE_URL = API_URL+"/contract_company_group/my_company_contracted_company/";
export const TMS_RESPONSE_URL = API_URL+"/tms/my_tms/";
export const FAQ_URL = API_URL+"/faq/";
export const CONTRACT_DELETE_URL = API_URL+"/contract/";
export const CONTRACT_DETAIL_URL = API_URL+"/contract_company_group/contract_detail/";
export const OTHER_COMPANY_URL = API_URL+"/company/target_member_data/?id=";
export const PASSWORD_CHANGE_URL = API_URL+"/member/password_change/";
export const PASSWORD_RESET_URL = API_URL+"/member/password_reset/";
export const SIGN_CHANGE_URL = API_URL+"/member_file/uploads/";
export const ALARM_RESPONSE_URL = API_URL+"/alarm_history/data_list/?page=";
export const ALARM_VIEW_URL = API_URL+"/alarm_history/set_all_view/";
export const ALARM_DELETE_URL = API_URL+"/alarm_history/";
export const DRIVER_RESPONSE_URL = API_URL+"/waste_collect/my_driver_collect_list/";
export const DISPOSE_DATA_RESPONSE_URL = API_URL+"/dispose/my_driver_dispose_data/";
export const DRIVER_COMPANY_URL = API_URL+"/contract_company_group/my_company_contracted_company/";
export const LIST_DELETE_URL = API_URL+"/waste_collect/";
export const DISPOSE_WEARING_URL = API_URL+"/dispose/dispose_and_wearing/";
export const UNCOLLECT_UPLOAD_URL = API_URL+"/waste_collect/insert_un_collect/";
export const BUSINESS_LIST_URL = API_URL+"/company/children_company/";
export const BUSINESS_TOTAL_LIST_URL = API_URL+"/company/company_total_list/";
export const NEW_BUSINESS_URL = API_URL+"/company/children_company_file_upload/";
export const SIGN_URL = API_URL+"/contract_company_group/contract_sign/";
export const PRODUCT_LIST_URL = API_URL+"/trade/trade_list/?page=1&type=sell";
export const PRODUCT_SELL_LIST_URL = API_URL+"/trade/trade_list/?page=";
export const PRODUCT_SELL_DETAIL_URL = API_URL+"/trade/";
export const PRODUCT_REQUEST_URL = API_URL+"/trade_request/insert_trade_request/";
export const SELL_COMPLETE_ONE_URL = API_URL+"/trade_request/";
export const SELL_COMPLETE_TWO_URL = API_URL+"/trade/";
export const SELL_COMPLETE_THREE_URL = API_URL+"/trade_history/";
export const SELL_COMPLETE_FOUR_URL = API_URL+"/trade_request_history/";
export const SELL_DELETE_ONE_URL = API_URL+"/trade_request/";
export const SELL_DELETE_TWO_URL = API_URL+"/trade/";
export const SELL_DELETE_THREE_URL = API_URL+"/trade_request_history/";
export const BUY_WRITE_URL = API_URL+"/trade/insert_trade/";
export const BUY_UPDATE_URL = API_URL+"/trade/update_trade/";
export const POST_WEARING_URL = API_URL+"/wearing/wearing_sum/";
export const POST_PROCESSING_WEARING_URL = API_URL+"/wearing/process_wearing/";
export const GET_WEARING_LIST_URL = API_URL+"/wearing/my_wearing_list/";
export const GET_WEARING_PROCESS_LIST_URL = API_URL+"/wearing/my_wearing_process_list/";
export const GET_TREATMENT_DISPOSE_LIST_URL = API_URL+"/dispose/my_treatment_dispose_list/";
export const GET_TREATMENT_DISPOSE_DASHBOARD_LIST_URL = API_URL+"/dispose/my_treatment_dispose_dashboard_list/";
export const GET_COLLECT_LIST_URL = API_URL+"/waste_collect/get_collect_list/";
export const MY_PRODUCT_LIST_URL = API_URL+"/trade/my_trade_list/";
export const POST_COLLECT_DATA_URL = API_URL+"/waste_collect/children_company_collect/";
export const POST_PAYMENT_DATA_URL = API_URL+"/payment_report/children_company_collect/";
export const POST_MY_CONTRACT_URL = API_URL+"/contract_company_group/children_contract_list/";
export const POST_MULTI_MY_CONTRACT_URL = API_URL+"/contract_company_group/multi_children_contract_list/";
export const POST_TOTAL_MY_CONTRACT_URL = API_URL+"/contract_company_group/total_children_contract_list/";
export const POST_COLLECT_SUM_URL = API_URL+"/waste_collect/collect_sum/";
export const POST_DISPOSE_SUM_URL = API_URL+"/dispose/dispose_sum/";
export const SENDING_CODE_URL = API_URL+"/sms/send_code_sms/";
export const CHECK_CODE_URL = API_URL+"/auth/check_verification_code_sms/";
export const NEW_PASSWORD_URL = API_URL+"/auth/password_change/";
export const GET_DRIVER_LIST_URL = API_URL+"/company_member_group/data_list/";
export const CHECK_DRIVER_ID_URL = API_URL+"/auth/check_id/";
export const SAVE_DRIVER_ACCOUNT_URL = API_URL+"/auth/insert_driver/";
export const UPDATE_DRIVER_ACCOUNT_URL = API_URL+"/auth/update_driver/";
export const SAVE_DRIVER_EXCEL_URL = API_URL+"/auth/upload_driver_excel/";
export const DELETE_DRIVER_ACCOUNT_URL = API_URL+"/my_profile/";
export const UPDATE_DRIVER_LIST_URL = API_URL+"/my_profile/";
export const GET_WAVER_BAR_URL = API_URL+"/wasteverse_bar/data_list/";
export const CHECK_WAVER_BAR_NUMBER_URL = API_URL+"/wasteverse_bar/check_id/";
export const SAVE_WAVER_BAR_NUMBER_URL = API_URL+"/wasteverse_bar/";
export const SAVE_WAVER_BAR_EXCEL_URL = API_URL+"/wasteverse_bar/upload_wasteverse_bar_excel/";
export const UPDATE_WAVER_BAR_NUMBER_URL = API_URL+"/wasteverse_bar/";
export const DELETE_WAVER_BAR_NUMBER_URL = API_URL+"/wasteverse_bar/";
export const GET_BIN_LIST_URL = API_URL+"/waste_bin/data_list/";
export const GET_BIN_ALL_LIST_URL = API_URL+"/waste_bin/data_list_all/";
export const GET_BIN_COMPANY_URL = API_URL+"/contract_company_group/my_company_contracted_company/";
export const CHECK_BIN_ID_URL = API_URL+"/waste_bin/check_id/";
export const SAVE_BIN_ACCOUNT_URL = API_URL+"/waste_bin/";
export const SAVE_BIN_EXCEL_URL = API_URL+"/waste_bin/upload_waste_bin_excel/";
export const DELETE_BIN_ACCOUNT_URL = API_URL+"/waste_bin/";
export const UPDATE_BIN_LIST_URL = API_URL+"/waste_bin/";
export const GET_DISPOSE_LIST_URL = API_URL+"/dispose/my_dispose_list/";
export const GET_PROCESS_LIST_URL = API_URL+"/wearing/my_process_list/";
export const GET_DRIVER_DISPOSE_URL = API_URL+"/dispose/my_driver_dispose_list/";
export const COMPANY_DATA_URL = API_URL+"/company/data_list/";
export const EMITTER_COMPANY_DATA_URL = API_URL+"/company/data_list_no_child/";
export const POST_TARGET_COMPANY_URL = API_URL+"/contract_company_group/get_target_company/";
export const POST_PREV_COLLECT_URL = API_URL+"/waste_collect/children_company_collect_report_prev/";
export const POST_COLLECT_REPORT_SUM_URL = API_URL+"/waste_collect/children_company_collect_report/";
export const POST_SIGN_FILE_URL = API_URL+"/member_file/sign_file_upload/";
export const PATCH_COMPANY_DETAIL_URL = API_URL+"/company_detail/";
export const MEMBER_FILE_URL = API_URL+"/member_file/";
export const POST_PAYMENT_LOG_URL = API_URL+"/payment_report/insert_payment_log/";
export const POST_PAYMENT_REPORT_URL = API_URL+"/payment_report/insert_payment/";
export const POST_TAX_URL = API_URL+"/taxbill/regist_issue/";
export const POST_TAX_PDF_URL = API_URL+"/taxbill/get_pdf_url/";
export const POST_WASTE_COLLECTION_URL = API_URL+"/waste_collect/insert_collect/";
export const INSERT_COLLECT_WITHOUT_TMS_URL = API_URL+"/waste_collect/insert_collect_without_tms/";
export const GET_EMITTER_ALLBARO_DATA_URL = API_URL+"/allbaro_request/get_my_allbaro_request_list/";
export const GET_ALLBARO_DATA_URL = API_URL+"/allbaro_request/get_my_collection_allbaro_list/";
export const GET_CAR_URL = API_URL+"/car/data_list/";
export const CHECK_CAR_NUMBER_URL = API_URL+"/car/check_number/";
export const SAVE_CAR_NUMBER_URL = API_URL+"/car/";
export const SAVE_CAR_EXCEL_URL = API_URL+"/car/upload_car_number_excel/";
export const DELETE_CAR_NUMBER_URL = API_URL+"/car/";
export const UPDATE_CAR_DATA_URL = API_URL+"/car/update_car_data/";
export const GET_BUSINESS_COMPANY_URL = API_URL+"/company/company_total_list/";
export const UPLOAD_COMPANY_LIST_EXCEL_URL = API_URL+"/company/children_company_file_upload/";
export const CODE_URL = API_URL+"/code/";
export const TERMS_URL = API_URL+"/terms/";
export const GET_ALLBARO_FILE_URL = API_URL+"/allbaro/file_data_list/";
export const SEND_ALLBARO_FAX_URL = API_URL+"/fax/send_allbaro_fax/";
export const REGIST_TAX_BILL_URL = API_URL+"/taxbill/regist_issue/";
export const GET_ADVERTISEMENT_URL = API_URL+"/advertisement/";
export const TRADE_REPLAY_URL = API_URL+"/trade_replay/";
export const WITHDRAWL_URL = API_URL+"/member/withdraw_user/";
export const COLLECTION_SETTLEMENT_LIST_URL = API_URL+"/contract_company_group/my_company_contracted_company/";
export const GET_ALL_COMPANY_LIST_URL = API_URL+"/destination_company/data_list/"
export const GET_MEMBER_SIGN_URL = API_URL+"/member/get_member_sign/"
export const OUTSOURCING_CONTRACT_PATCH_URL = API_URL+"/destination_contract/"
export const OUTSOURCING_CONTRACT_WRITE_URL = API_URL+"/destination_contract/make_outsourcing_contract/"
export const OUTSOURCING_CONTRACT_URL = API_URL+"/destination_contract/outsourcing_contract_list/"
export const OUTSOURCING_CONTRACT_DETAIL_URL = API_URL+"/destination_contract/outsourcing_contract_detail/"
export const OUTSOURCING_SIGN_URL = API_URL+"/destination_contract/outsourcing_sign/"
export const OUTSOURCING_CONTRACT_FILE_URL = API_URL+"/destination_contract/outsourcing_contract_file/"
export const PATCH_OUTSOURCING_CONTRACT_URL = API_URL+"/destination_contract/patch_outsourcing_contract/"
export const OUTSOURCING_FILE_DOWNLOAD_URL = API_URL+"/destination_contract/outsourcing_file_download/"
export const OUTSOURCING_CONTRACTED_COMPANY_URL = API_URL+"/destination_contract/my_contracted_company/"
export const CMS_DATA_URL = API_URL+"/contract_company_group/my_contract_list_all/"
export const COMPANY_FROM_ID_URL = API_URL+"/contract_company_group/get_target_company/"
export const TOTAL_COMPANY_PAYMENT_URL = API_URL+"/company/is_payment_total/"
export const SAVE_CMS_DATA_URL = API_URL+"/contract/save_cms_data/"
export const DOWNLOAD_COLLECT_EXCEL_URL = API_URL+"/summary_waste_collect/download_collect_excel/"
export const CAR_LIST_ALL_URL = API_URL+"/car/data_list_all/"
export const MULTI_CHILD_COMPANY_URL = API_URL+"/company/child_company/"
export const DISPOSE_COMPLETE_URL = API_URL+"/dispose/dispose_complete/"
export const DISPOSE_LIST_COMPLETE_URL = API_URL+"/dispose/dispose_list_complete/"

export const REFRESH_TOKEN_URL = API_URL+"/token/refresh/";
// export const 
// export const REQUEST_PASSWORD_URL = "api/auth/forgot-password";

// //export const ME_URL = "api/me";

// export const LOGIN_URL = "/rest/auth/signin";
// export const THE_APT_LOGIN_URL = "/rest/auth/theAptSignin";
// export const ME_URL = "/rest/me/manager";

// export const REFRESH_URL = "/rest/auth/manager/refreshToken";

// export const PHONE_SEND_NUMBER = "/rest/auth/send/authNumber"
// export const PHONE_SEND_NUMBER_CHECK = "/rest/auth/send/authNumberCheck"

// export function login(userId, passwd, userType) {
//   return axiosApi.post(LOGIN_URL, { userId, passwd, userType});
// }

export function login(params) {
  return axios.post(LOGIN_URL, params)
}

export function register(data) {
  return axios.post(REGISTER_URL, data, {headers : {'Content-Type' : 'multipart/form-data'} });
}

export function checkId(param) {
  return axios.post(CHECK_ID_URL, param, {headers: {}});
}

export function getTerms() {
  return axios.get(TERMS_URL)
}

export function getCode() {
  return axios.get(CODE_URL)
}

export function mainResponse(param) {
  return axios.post(MAIN_RESPONSE_URL, param);
}

export function dashboardResponse() {
  return axios.get(DASHBOARD_URL);
}

export function newsResponse() {
  return axios.get(NEWS_URL);
}

export function getNewsByPage(params) {
  return axios.get(NEWS_BY_PAGE_URL + '?page=' + params.page);
}

export function companyListCall(params) {
  return axios.get(COMPANY_DATA_URL + '?page=' + params.page + '&type=' + params.type + '&search='+params.search + '&number=' + (params.number ?? ''))
}

export function emitterListCall(params) {
  return axios.get(EMITTER_COMPANY_DATA_URL + '?page=' + params.page + '&type=' + params.type + '&search='+params.search)
}

export function contractCall(params) {
  return axios.get(CONTRACT_URL + '?page=' + params.page + '&state=Y&company=' + params.company)
}

export function multiContractCall(params) {
  return axios.get(MULTI_CONTRACT_URL + '?page=' + params.page + '&state=Y&company=' + params.company)
}

export function uncontractCall(params) {
  return axios.get(CONTRACT_URL + '?page=' + params.page + '&state=N&company=' + params.company)
}

export function multiUncontractCall(params) {
  return axios.get(MULTI_CONTRACT_URL + '?page=' + params.page + '&state=N&company=' + params.company)
}

export function allStateContractCall(params) {
  return axios.get(ALL_STATE_CONTRACT_URL + '?page=' + params.page + '&subject=' + params.subject + '&collect_zone=' + params.collect_zone)
}

export function contractWriteResponse(params) {
  return axios.post(CONTRACT_WRITE_URL, params, {headers : {'Content-Type' : 'multipart/form-data'} });
}

export function contractWriteHistory(params) {
  return axios.post(CONTRACT_WRITE_HISTORY_URL, params);
}

export function tradeHistoryCall(param) {
  return axios.get(TRADE_HISTORY_URL + '?page=' + param.page + '&company=' + param.company + '&start_ym=' + param.start_ym + '&end_ym=' + param.end_ym);
}

export function multiTradeHistoryCall(param) {
  return axios.get(MULTI_TRADE_HISTORY_URL + '?page=' + param.page + '&company=' + param.company + '&start_ym=' + param.start_ym + '&end_ym=' + param.end_ym);
}

export function totalTradeHistoryCall(param) {
  return axios.get(TOTAL_TRADE_HISTORY_URL + '?page=' + param.page + '&company=' + param.company + '&start_ym=' + param.start_ym + '&end_ym=' + param.end_ym);
}

export function companyResponse(param, urlplus) {
  return axios.patch(COMPANY_URL + urlplus + "/", param);
}

export function memberResponse(param, urlplus) {
  return axios.patch(MEMBER_RESPONSE_URL + urlplus + "/", param);
}

export function tmsCompanyResponse(company) {
  return axios.get(TMS_COMPANY_RESPONSE_URL + '?id=' + company + '&company_type=collection');
}
export function tmsResponse(param) {
  return axios.post(TMS_RESPONSE_URL, param);
}

export function chartResponse(param) {
  return axios.post(MAIN_RESPONSE_URL, param);
}

export function chartMultiResponse(param) {
  return axios.post(CHART_MULTI_URL, param);
}

export function chartTotalResponse(param) {
  return axios.post(CHART_TOTAL_URL, param);
}

export function faqResponse() {
  return axios.get(FAQ_URL + '?page=1');
}

export function contractDetailResponse(params) {
  return axios.get(CONTRACT_DETAIL_URL + params);
}

export function patchContract(fd) {
  return axios.post(CONTRACT_PATCH_URL, fd, 
  {headers : {'Content-Type' : 'multipart/form-data'} }
  );
}

export function otherCompanyResponse(params) {
  return axios.get(OTHER_COMPANY_URL + params);
}

export function contractDelete(params) {
  return axios.patch(CONTRACT_DELETE_URL + params + "/", {status : 'N'});
}

export function changeContractSettlement(id, date) {
  return axios.patch(CONTRACT_DELETE_URL + id + "/", {settlement_date : date});
}

export function passwordChange(params) {
  return axios.post(PASSWORD_CHANGE_URL, params);
}

export function passwordReset(params) {
  return axios.post(PASSWORD_RESET_URL, params);
}

export function signChange(params) {
  return axios.post(SIGN_CHANGE_URL, params, {headers : {'Content-Type' : 'multipart/form-data'}});
}

export function settingChange(param, urlplus) {
  return axios.patch(MEMBER_RESPONSE_URL + urlplus + "/", param)
}

export function settingConfirm(param) {
  return axios.get(MEMBER_RESPONSE_URL + param + "/")
}

export function alarmResponse(param) {
  return axios.get(ALARM_RESPONSE_URL + param.page + "&member_id=" + param.memberId)
}

export function alarmView(param) {
  return axios.post(ALARM_VIEW_URL, param)
}

export function alarmDelete(param, urlplus) {
  return axios.patch(ALARM_DELETE_URL + urlplus + "/", param)
}

export function driverResponse(param) {
  return axios.post(DRIVER_RESPONSE_URL, param)
}

export function driverCompanyResponse(param) {
  return axios.get(DRIVER_COMPANY_URL + param)
}

export function disposeDataResponse(param) {
  return axios.post(DISPOSE_DATA_RESPONSE_URL, param)
}

export function listDelete(param) {
  return axios.delete(LIST_DELETE_URL + param + "/")
}

export function disposeWearing(param) {
  return axios.post(DISPOSE_WEARING_URL, param)
}

export function uncollectUpload(param) {
  return axios.post(UNCOLLECT_UPLOAD_URL, param)
}

// 사업장 리스트
export function getBusinessList(param) {
  return axios.get(BUSINESS_LIST_URL + param)
}
export function getBusinessTotalList(param) {
  return axios.get(BUSINESS_TOTAL_LIST_URL + param)
}
export function postCollectData(param) {
  return axios.post(POST_COLLECT_DATA_URL, param)
}
export function postMyContract(param) {
  return axios.post(POST_MY_CONTRACT_URL, param)
}
export function postMultiMyContract(param) {
  return axios.post(POST_MULTI_MY_CONTRACT_URL, param)
}
export function postTotalMyContract(param) {
  return axios.post(POST_TOTAL_MY_CONTRACT_URL, param)
}

export function postPaymentData(param) {
  return axios.post(POST_PAYMENT_DATA_URL, param)
}

export function patchBusinessList(id, param) {
  return axios.patch(COMPANY_URL + id + "/", param)
}

export function setNewBusinessList(param) {
  return axios.post(NEW_BUSINESS_URL, param, {headers: {'Content-Type': 'multipart/form-data'},})
}

export function doSign(params) {
  return axios.post(SIGN_URL, params)
}

export function getProductList() {
  return axios.get(PRODUCT_LIST_URL)
}

export function getSellProductList(param) {
  return axios.get(PRODUCT_SELL_LIST_URL + param.page + '&type=sell&search=' + param.search + '&product_type=' + param.product_type)
}

export function getBuyProductList(param) {
  return axios.get(PRODUCT_SELL_LIST_URL + param.page + '&type=buy&search=' + param.search + '&product_type=' + param.product_type)
}

export function getSellProductDetail(param) {
  return axios.get(PRODUCT_SELL_DETAIL_URL + param + '/')
}

export function postTradeRequest(param) {
  return axios.post(PRODUCT_REQUEST_URL, param)
}

// 판매완료 함수들
export function sellComplete1(param, date) {
  return axios.patch(SELL_COMPLETE_ONE_URL + param + '/', {state : 'Y', complete_date : date})
}
export function sellComplete2(param, date) {
  return axios.patch(SELL_COMPLETE_TWO_URL + param + '/', {state : 'Y', complete_date : date})
}
export function sellComplete3(param) {
  return axios.post(SELL_COMPLETE_THREE_URL, param)
}
export function sellComplete4(param) {
  return axios.post(SELL_COMPLETE_FOUR_URL, param)
}

// 판매취소 함수들
export function sellDelete1(param) {
  return axios.patch(SELL_DELETE_ONE_URL + param + '/', {status : 'N'})
}
export function sellDelete2(param) {
  return axios.patch(SELL_DELETE_TWO_URL + param + '/', {state : 'N'})
}
export function sellDelete3(param) {
  return axios.post(SELL_DELETE_THREE_URL, param)
}

export function postBuyWrite(param) {
  return axios.post(BUY_WRITE_URL, param, {headers: {'Content-Type': 'multipart/form-data'}})
}

export function postBuyUpdate(param) {
  return axios.post(BUY_UPDATE_URL, param, {headers: {'Content-Type': 'multipart/form-data'}})
}

//메인 홈 데이터
export function postWaste(url, param) {
  return axios.post(API_URL + url, param)
}
export function postWearing(param) {
  return axios.post(POST_WEARING_URL, param)
}
export function postProcessingWearing(param) {
  return axios.post(POST_PROCESSING_WEARING_URL, param)
}
export function postCollectSum(param) {
  return axios.post(POST_COLLECT_SUM_URL, param)
}
export function postDisposeSum(param) {
  return axios.post(POST_DISPOSE_SUM_URL, param)
}

export function getWearingList(param) {
  return axios.get(GET_WEARING_LIST_URL
    + '?page=' + param.page + '&company=' + param.company + '&start_date=' + param.start_date + '&end_date=' + param.end_date + '&company_name=' + (param.company_name || '') + '&company_number=' + (param.company_number || '')
    )
}

export function getWearingProcessList(param) {
  return axios.get(GET_WEARING_PROCESS_LIST_URL
    + '?page=' + param.page + '&year=' + (param.year || '') + '&month=' + (param.month || '') + '&company_name=' + (param.company_name || '') + '&company_number=' + (param.company_number || '')
    )
}

export function getTreatmentDisposeList(param) {
  return axios.get(GET_TREATMENT_DISPOSE_LIST_URL
    + '?page=' + param.page + '&year=' + (param.year || '') + '&month=' + (param.month || '') + '&company_name=' + (param.company_name || '') + '&company_number=' + (param.company_number || '')
    )
}

export function getTreatmentDisposeDashboardList() {
  return axios.get(GET_TREATMENT_DISPOSE_DASHBOARD_LIST_URL)
}

export function getCollectList(param) {
  return axios.get(GET_COLLECT_LIST_URL
    + '?page=' + param.page + '&driver_company=' + param.driver_company + '&start_date=' + param.start_date + '&end_date=' + param.end_date
    + '&company_name=' + param.company_name + '&collect_zone=' + param.collect_zone + '&car=' + param.car + '&driver=' + param.driver
    )
}

export function getMyProduct(param) {
  return axios.get(MY_PRODUCT_LIST_URL + '?page=' + param.page + '&member=' + param.member + '&search=' + param.search + '&product_type=' + param.product_type)
}

export function postSendingCode(param) {
  return axios.post(SENDING_CODE_URL, param)
}

export function postCheckCode(param) {
  return axios.post(CHECK_CODE_URL, param)
}

export function postSetPassword(param) {
  return axios.post(NEW_PASSWORD_URL, param)
}

// 운반기사 관리
export function getDriverList(param) {
  return axios.get(GET_DRIVER_LIST_URL + '?page=' + param.page + '&company=' + param.company)
}
export function checkDriverId(param) {
  return axios.post(CHECK_DRIVER_ID_URL, param, {headers: {}})
}
export function saveDriverAccount(param) {
  return axios.post(SAVE_DRIVER_ACCOUNT_URL, param)
}
export function updateDriverAccount(param) {
  return axios.post(UPDATE_DRIVER_ACCOUNT_URL, param)
}
export function saveDriverExcel(param) {
  return axios.post(SAVE_DRIVER_EXCEL_URL, param, { headers: { 'Content-Type': 'multipart/form-data' },})
}
export function deleteDriverAccount(param, id) {
  return axios.patch(DELETE_DRIVER_ACCOUNT_URL + id + '/', param)
}
export function updateDriverList(param, id) {
  return axios.patch(UPDATE_DRIVER_LIST_URL + id + '/', param)
}

// 웨버바 관리
export function getWaverBarList(param) {
  return axios.get(GET_WAVER_BAR_URL + '?page=' + param.page + '&company=' + param.company)
}
export function checkWaverBarNumber(param) {
  return axios.post(CHECK_WAVER_BAR_NUMBER_URL, param, {headers: {}})
}
export function saveWaverBarNumber(param) {
  return axios.post(SAVE_WAVER_BAR_NUMBER_URL, param)
}
export function saveWaverBarExcel(param) {
  return axios.post(SAVE_WAVER_BAR_EXCEL_URL, param, { headers: { 'Content-Type': 'multipart/form-data' },})
}
export function updateWaverBarNumber(param, id) {
  return axios.patch(UPDATE_WAVER_BAR_NUMBER_URL + id + '/', param)
}
export function deleteWaverBarNumber(param, id) {
  return axios.patch(DELETE_WAVER_BAR_NUMBER_URL + id + '/', param)
}

// 쓰레기통 관리
export function getBinList(param) {
  return axios.get(GET_BIN_LIST_URL + '?page=' + param.page + '&company=' + param.company)
}
export function getBinAllList(param) {
  return axios.get(GET_BIN_ALL_LIST_URL + '?company=' + param.company)
}
export function getBinCompany(id) {
  return axios.get(GET_BIN_COMPANY_URL + '?id=' + id + '&company_type=emitter')
}
export function checkBinId(param) {
  return axios.post(CHECK_BIN_ID_URL, param, {headers: {}})
}
export function saveBinAccount(param) {
  return axios.post(SAVE_BIN_ACCOUNT_URL, param)
}
export function saveBinExcel(param) {
  return axios.post(SAVE_BIN_EXCEL_URL, param, { headers: { 'Content-Type': 'multipart/form-data' },})
}
export function deleteBinAccount(param, id) {
  return axios.patch(DELETE_BIN_ACCOUNT_URL + id + '/', param)
}
export function updateBinList(param, id) {
  return axios.patch(UPDATE_BIN_LIST_URL + id + '/', param)
}

// 차량번호 관리
export function getCarList(param) {
  return axios.get(GET_CAR_URL + '?page=' + param.page + '&company=' + param.company)
}
export function checkCarNumber(param) {
  return axios.post(CHECK_CAR_NUMBER_URL, param, {headers: {}})
}
export function saveCarNumber(param) {
  return axios.post(SAVE_CAR_NUMBER_URL, param)
}
export function saveCarExcel(param) {
  return axios.post(SAVE_CAR_EXCEL_URL, param, { headers: { 'Content-Type': 'multipart/form-data' },})
}
export function deleteCarNumber(param, id) {
  return axios.patch(DELETE_CAR_NUMBER_URL + id + '/', param)
}
export function updateCarData(param) {
  return axios.post(UPDATE_CAR_DATA_URL, param)
}

export function getDisposeList(param) {
  return axios.get(GET_DISPOSE_LIST_URL 
        + '?page=' + param.page + '&driver_company=' + param.driver_company + '&start_date=' + param.start_date + '&end_date=' + param.end_date
        + '&company_name=' + param.company_name + '&collect_zone=' + param.collect_zone + '&car=' + param.car + '&driver=' + param.driver
    )
}

export function getProcessList(param) {
  return axios.get(GET_PROCESS_LIST_URL + '?page=' + param.page + '&company=' + param.company + '&start_date=' + param.start_date+ '&end_date=' + param.end_date + '&company_name=' + (param.company_name || '') + '&company_number=' + (param.company_number || ''))
}

export function getDriverDispose(param) {
  return axios.get(GET_DRIVER_DISPOSE_URL + '?page=' + param.page + '&company=' + param.company + '&member=' + param.member + '&start_date=' + param.start_date+ '&end_date=' + param.end_date)
}

export function postTargetCompany(param) {
  return axios.post(POST_TARGET_COMPANY_URL, param)
}

export function postPrevCollect(param) {
  return axios.post(POST_PREV_COLLECT_URL, param)
}

export function postCollectReportSum(param) {
  return axios.post(POST_COLLECT_REPORT_SUM_URL, param)
}

export function postSignFile(param) {
  return axios.post(POST_SIGN_FILE_URL, param, { headers: { 'Content-Type': 'multipart/form-data' }, })
}

export function patchCompanyData(id, param) {
  return axios.patch(COMPANY_URL + id + '/', param)
}

export function patchProfileData(id, param) {
  return axios.patch(MEMBER_RESPONSE_URL + id + '/', param)
}

export function postMemberFile(param) {
  return axios.post(SIGN_CHANGE_URL, param, { headers: { 'Content-Type': 'multipart/form-data' }, })
}

export function patchCompanyDetail(id, param) {
  return axios.patch(PATCH_COMPANY_DETAIL_URL + id + '/', param)
}

export function deleteMemberFile(param) {
  return axios.delete(MEMBER_FILE_URL + param + '/')
}

export function getMyProfile(id) {
  return axios.get(MEMBER_RESPONSE_URL + id + '/')
}

export function getPaymentList(url, params) {
  return axios.get(API_URL + url + params.company + '&date=' + params.date)
}

export function postPaymentLog(params) {
  return axios.post(POST_PAYMENT_LOG_URL, params)
}

export function postPaymentReport(params) {
  return axios.post(POST_PAYMENT_REPORT_URL, params)
}

export function getSettlement(url) {
  return axios.get(API_URL + url)
}

export function postTax(params) {
  return axios.post(POST_TAX_URL, params)
}

export function getCompanyOrder(data) {
  return axios.get(COMPANY_URL + data + '/')
}

export function postTaxPdf(params) {
  return axios.post(POST_TAX_PDF_URL, params)
}

export function postWasteData(fd) {
  return axios.post(POST_WASTE_COLLECTION_URL, fd, {headers: {'Content-Type': 'multipart/form-data'}})
}

export function postWasteCollection(params) {
  return axios.post(POST_WASTE_COLLECTION_URL, params)
}

export function getEmitterAllbaroData(params) {
  return axios.get(GET_EMITTER_ALLBARO_DATA_URL + '?page=' + params.page + '&company=' + params.company)
}

export function getAllbaroData(params) {
  return axios.get(GET_ALLBARO_DATA_URL + '?page=' + params.page + '&company=' + params.company)
}

// 종합배출자 사업장 목록
export function getBusinessCompany(param) {
  return axios.get(GET_BUSINESS_COMPANY_URL + '?id=' + param)
}
export function deleteChildrenCompanyList(id, param) {
  return axios.patch(COMPANY_URL + id + '/', param)
}
export function uploadCompanyListExcel(fd) {
  return axios.post(UPLOAD_COMPANY_LIST_EXCEL_URL, fd, { headers: { 'Content-Type': 'multipart/form-data' }})
}

export function getAllbaroFileList(params) {
  return axios.get(GET_ALLBARO_FILE_URL + '?company=' + params.id + '&year=' + params.year)
}

export function sendAllbaroFax(fd) {
  return axios.post(SEND_ALLBARO_FAX_URL, fd, {headers: {'Content-Type' : 'multipart/form-data'}})
}

export function fromRsData(id) {
  return axios.get(COMPANY_URL + id + '/')
}
export function toRsData(id) {
  return axios.get(COMPANY_URL + id + '/')
}
export function registTaxBill(param) {
  return axios.post(REGIST_TAX_BILL_URL, param)
}
export function getAdvertisement() {
  return axios.get(GET_ADVERTISEMENT_URL + '?page=1')
}

export function postReplay(param) {
  return axios.post(TRADE_REPLAY_URL, param)
}
export function patchReplay(id) {
  return axios.patch(TRADE_REPLAY_URL + id + '/', {status: 'N'})
}
export function sendReplay(param) {
  return axios.post(TRADE_REPLAY_URL, param)
}

export function withdrawlUser(param) {
  return axios.post(WITHDRAWL_URL, param)
}
export function deleteAuth() {
  return delete axios.defaults.headers.common['Authorization']
}

export function patchTradeRequest1(id) {
  return axios.patch(SELL_COMPLETE_ONE_URL + id + '/', {status : 'N'})
}
export function patchTradeRequest2(id) {
  return axios.patch(SELL_COMPLETE_TWO_URL + id + '/', {state : 'N'})
}
export function patchTradeRequest3(param) {
  return axios.post(SELL_COMPLETE_FOUR_URL, param)
}

export function patchtradeReply(id) {
  return axios.patch(TRADE_REPLAY_URL + id + '/', {status: 'N'})
}

export function getCollectionSettlementList(id) {
  return axios.get(COLLECTION_SETTLEMENT_LIST_URL + '?id=' + id + '&company_type=emitter')
}

export function getAllCompanyList(params) {
  return axios.get(GET_ALL_COMPANY_LIST_URL + '?search=' + params.search + '&type=' + params.type)
}

export function getMemberSignFile() {
  return axios.get(GET_MEMBER_SIGN_URL)
}

export function postOutsourcingContractWrite(fd) {
  return axios.post(OUTSOURCING_CONTRACT_WRITE_URL, fd, { headers: { 'Content-Type': 'multipart/form-data' }})
}

export function outsourcingContractCall(params) {
  return axios.get(OUTSOURCING_CONTRACT_URL + '?page=' + params.page + '&state=' + params.state + '&company=' + params.company + '&company_to=' + params.company_to)
}

export function outsourcingContractDetail(params) {
  return axios.get(OUTSOURCING_CONTRACT_DETAIL_URL + params)
}

export function doOutsourcingSign(params) {
  return axios.post(OUTSOURCING_SIGN_URL, params)
}

// export function patchOutsourcingContract(fd) {
//   return axios.post(OUTSOURCING_CONTRACT_FILE_URL, fd, {headers : {'Content-Type' : 'multipart/form-data'} });
// }

export function patchOutsourcingContract(params) {
  return axios.post(PATCH_OUTSOURCING_CONTRACT_URL, params);
}

export function downloadOutsourcingFile(id) {
  return axios.post(OUTSOURCING_FILE_DOWNLOAD_URL, id);
}

export function outsourcingContractDelete(id) {
  return axios.patch(OUTSOURCING_CONTRACT_PATCH_URL + id + "/", {status : 'N'});
}

export function getCmsData(params) {
  return axios.get(CMS_DATA_URL + '?state=Y' + '&company=' + params.company);
}

export function postCompanyFromId(params) {
  return axios.post(COMPANY_FROM_ID_URL, params);
}

export function getTotalCompanyPayment(id) {
  return axios.get(TOTAL_COMPANY_PAYMENT_URL + '?company=' + id);
}

export function saveCmsData(fd) {
  return axios.post(SAVE_CMS_DATA_URL, fd, {headers: {'Content-Type': 'multipart/form-data'}});
}

export function downloadCollectExcel(params) {
  return axios.get(DOWNLOAD_COLLECT_EXCEL_URL + '?company=' + params.company + '&company_name=' + params.company_name + '&price=' + params.price + '&ym=' + params.ym + '&start_date=' + params.start_date + '&end_date=' + params.end_date);
}

export function getContractedEmitter(id) {
  return axios.get(DRIVER_COMPANY_URL + '?id=' + id + '&company_type=emitter')
}

export function getContractedTreatment(id) {
  return axios.get(DRIVER_COMPANY_URL + '?id=' + id + '&company_type=treatment')
}

export function getOutsourcingContracted(id) {
  return axios.get(OUTSOURCING_CONTRACTED_COMPANY_URL + '?id=' + id)
}

export function getCarListAll(id) {
  return axios.get(CAR_LIST_ALL_URL + '?company=' + id)
}

export function insertCollect(fd) {
  return axios.post(INSERT_COLLECT_WITHOUT_TMS_URL, fd, {headers: {'Content-Type': 'multipart/form-data'}})
}

export function getMultiChildCompany(id) {
  return axios.get(MULTI_CHILD_COMPANY_URL + '/?id=' + id)
}

export function disposeComplete(params) {
  return axios.post(DISPOSE_COMPLETE_URL, params)
}

export function disposeListComplete(params) {
  return axios.post(DISPOSE_LIST_COMPLETE_URL, params)
}



// export function getMyProduct(param) {
//   return axios.get(MY_PRODUCT_LIST_URL + '?page=' + param.page + '&member=' + param.member + '&search=' + param.search)
// }

// export function file(param, urlplus) {
//   return axios.patch(ALARM_DELETE_URL + urlplus + "/", param)
// }
// SIGN_CHANGE_URL
// export function theAptLogin(ssotoken, ssoid) {
//   return axios.get(THE_APT_LOGIN_URL + '?ssotoken=' + ssotoken + '&ssoid='+ssoid)
// }

// const instance = axios.create();
// instance.interceptors.request.use(
//   config => {
//     const {
//       auth: { refreshToken }
//     } = store.getState();

//     if (refreshToken) {
//       config.headers.Authorization = `Bearer ${refreshToken}`;
//     }

//     return config;
//   },
//   err => Promise.reject(err)
// );

// export function refresh(refreshToken) {
//   return instance.get(REFRESH_URL, {});
// }

// export function mobileApprovalRefresh(token) {
//   let config = {
//     headers : {
//       Authorization : `Bearer `
//     }
//   };
//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }
//   return instance.get(REFRESH_URL, config);
// }

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  return axios.post(MY_PROFILE_URL, {});
}

// export function sendNumber(data) {
//   return axios.post(PHONE_SEND_NUMBER, data );
// }

// export function sendNumberCheck(data) {
//   return axios.post(PHONE_SEND_NUMBER_CHECK, data );
// }

export function postTestData(url) {
  return axios.post(API_URL + url)
}